import { render, staticRenderFns } from "./NotFoundPage.vue?vue&type=template&id=0bf13b47&scoped=true&"
var script = {}
import style0 from "./NotFoundPage.vue?vue&type=style&index=0&id=0bf13b47&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf13b47",
  null
  
)

export default component.exports